module.exports = __webpack_public_path__ + "assets/img/4.9c7e7f0d.png";